import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';
import { FlashJustDragged } from '../moveCard/flashJustDragged';

const { registerReducer, registerMiddleware, dispatch } = useStorymapStore();

export class SetPersonaManagementIsOpen extends Action<StorymapState> {
    public static ACTION_TYPE = 'SetPersonaManagementIsOpen';

    public constructor(
        public isOpen: boolean,
        public startGeneratingWithAi: boolean = false,
        public onAiDialogCloseCallback?: () => void,
        public onPersonaManagementCloseCallback?: () => void
    ) {
        super(SetPersonaManagementIsOpen.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SetPersonaManagementIsOpen): Promise<boolean> => {
    if (!action.isOpen) {
        dispatch(new FlashJustDragged());
    }

    return true;
};

const reducer = (state: StorymapState, action: SetPersonaManagementIsOpen): void => {
    state.personaManagementPopupState.startGeneratingWithAi = state.isPublishedRecipient ? false : action.startGeneratingWithAi;

    if (action.isOpen && action.onAiDialogCloseCallback) {
        state.personaManagementPopupState.onAiDialogClose = action.onAiDialogCloseCallback;
    }
    if (action.isOpen && action.onPersonaManagementCloseCallback) {
        state.personaManagementPopupState.onPersonaManagementClose = action.onPersonaManagementCloseCallback;
    }

    if (action.isOpen === false) {
        state.personaManagementPopupState.onAiDialogClose = null;
        state.personaManagementPopupState.onPersonaManagementClose = null;
    }

    state.personaManagementPopupState.isOpen = action.isOpen;
};

//@ts-ignore
registerMiddleware(SetPersonaManagementIsOpen.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SetPersonaManagementIsOpen.ACTION_TYPE, reducer);
